import { Controller } from "stimulus"

// "Spendenbetrag ändern" on "Meine Artikel": turns "Meine Spende" into a field with the cursor in it.
export default class extends Controller {
  static targets = ["display", "form", "input", "button"]
  static values = { open: Boolean }

  connect() {
    // Reopens the field after a failed change (?change_donation=1).
    if (this.openValue) this.show()
  }

  open(event) {
    event.preventDefault()
    this.show()
  }

  cancel() {
    this.formTarget.reset()
    this.toggle(false)
  }

  show() {
    this.toggle(true)
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  toggle(editing) {
    this.displayTarget.hidden = editing
    this.buttonTarget.hidden = editing
    this.formTarget.hidden = !editing
  }
}
